export const NvidiaDashboardTemplate = `
{
  "widgetType": "Group",
  "title": {
    "dataType": "Title",
    "value": "Nvidia%20GPU%20Dashboard"
  },
  "position": {
    "x": 0,
    "y": 0,
    "w": 12,
    "h": 12
  },
  "children": [
    {
      "widgetType": "Markdown",
      "content": "### How to use this dashboard\\n\\nUse the guages to get an idea of the overall health of all gpus, then use the timeseries charts to understand the outliers and trends over time. \\n\\nAfter identifying outliers use the variables to focus specifically on that host or gpu.\\n\\nAvailable variables:\\n* Environment - Filter to a specific evnironment's gpus. Settable in the global environment selector up top\\n* Hostname - Filter to an individual host. Settable as a dashboard variable\\n* GPU - Filter to a specific gpu on the host. Settable as a dashboard variable",
      "position": {
        "x": 0,
        "y": 0,
        "w": 6,
        "h": 2
      },
      "children": []
    },
    {
      "widgetType": "Markdown",
      "content": "### How to get this dashboard set up\\n\\nIn order to get this dashboard loaded up with data, you need to install the [Nvidia DCGM Exporter](https://github.com/NVIDIA/dcgm-exporter) into your cluster, then write the data exported by those exporters to the metoro exporter in your cluster.\\n\\nIf you have already set up the otel exporter with other prometheus exporters before, just do the same for the Nvidia DCGM Exporter.\\n\\nAlternatively, you can follow [this](https://github.com/metoro-io/metoro_examples/tree/main/metrics/otel-collector/nvidia_dashboard_setup) example in github which will walk you through the install process for the exporter and the otel collector",
      "position": {
        "x": 6,
        "y": 0,
        "w": 6,
        "h": 2
      },
      "children": []
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Temperature"
      },
      "position": {
        "x": 0,
        "y": 2,
        "w": 12,
        "h": 5
      },
      "children": [
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg GPU Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 0,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_TEMP",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_TEMP",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "max",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20GPU%20Temperature"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "Cel"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_TEMP",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "Cel"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Temperature%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min GPU Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 1,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_TEMP",
              "aggregation": "min",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max GPU Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 1,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_TEMP",
              "aggregation": "max",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg Mem Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 2,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEMORY_TEMP",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEMORY_TEMP",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "max",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20Mem%20Temperature"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "Cel"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEMORY_TEMP",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "Cel"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Memory%20Temperature%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 2,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min Mem Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 3,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEMORY_TEMP",
              "aggregation": "min",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max Mem Temp",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 3,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEMORY_TEMP",
              "aggregation": "max",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max",
          "showAbsoluteValue": true,
          "unitOverride": "Cel"
        }
      ]
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Utilization"
      },
      "position": {
        "x": 0,
        "y": 7,
        "w": 12,
        "h": 9
      },
      "children": [
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg GPU Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 0,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20GPU%20Utilization"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "%"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_UTIL",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "GPU%20Utilization%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min GPU Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 1,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max GPU Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 1,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_GPU_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host",
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg Mem Copy Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 2,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEM_COPY_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEM_COPY_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20Mem%20Copy%20Utilization"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "%"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEM_COPY_UTIL",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Mem%20Copy%20Utilization%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 2,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min Mem Copy Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 3,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEM_COPY_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max Mem Copy Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 3,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_MEM_COPY_UTIL",
              "aggregation": "max",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg Encoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 4,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 4,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20Encoder%20Utilization"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "%"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Encoder%20Utilization%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 4,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min Encoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 5,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max Encoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 5,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Avg Decoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 6,
            "w": 2,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "avg"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 6,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_DEC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "avg",
          "mappings": [
            {
              "operator": ">",
              "value": 70,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<",
              "value": 70,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value"
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Avg%20Encoder%20Utilization"
          },
          "fontSize": "auto",
          "columnConfigs": [
            {
              "id": "attributes.Hostname",
              "isFilterable": true,
              "title": {
                "dataType": "Title",
                "value": "Hostname"
              }
            },
            {
              "id": "attributes.gpu",
              "title": {
                "dataType": "Title",
                "value": "GPU"
              }
            }
          ],
          "unitOverride": "%"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_DEC_UTIL",
              "aggregation": "max",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "%"
              },
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              },
              "splits": [
                "Hostname",
                "gpu"
              ]
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Decoder%20Utilization%20By%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 6,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Min Decoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 0,
            "y": 7,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "min"
        },
        {
          "widgetType": "Gauge",
          "value": 75,
          "label": "Max Decoder Utilization",
          "min": 0,
          "max": 100,
          "position": {
            "x": 1,
            "y": 7,
            "w": 1,
            "h": 1
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_ENC_UTIL",
              "aggregation": "avg",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host GPU"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "metoroQLQueries": [],
          "precision": 2,
          "reduceOption": "max"
        }
      ]
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Energy%20Consumption"
      },
      "position": {
        "x": 0,
        "y": 16,
        "w": 12,
        "h": 5
      },
      "children": [
        {
          "widgetType": "Stat",
          "position": {
            "x": 0,
            "y": 0,
            "w": 2,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_POWER_USAGE",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "lastNotNull",
          "mappings": [],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Current%20Total%20Power%20Draw"
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "W"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_POWER_USAGE",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "Hostname"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "lastNotNull",
          "mappings": [],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Current%20Total%20Power%20Draw%20By%20Host"
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "W"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_TOTAL_ENERGY_CONSUMPTION",
              "aggregation": "sum",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "W"
              },
              "splits": [
                "Hostname"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Energy%20Use%20By%20Host%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 0,
            "y": 2,
            "w": 2,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_TOTAL_ENERGY_CONSUMPTION",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [],
              "shouldNotReturn": true,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [
            {
              "formula": "a / 1000",
              "visualization": {}
            }
          ],
          "reduceOption": "sum",
          "mappings": [],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Total%20Energy%20Use"
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "J"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 2,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_TOTAL_ENERGY_CONSUMPTION",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "host",
                "Hostname"
              ],
              "shouldNotReturn": true,
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [
            {
              "formula": "a / 1000",
              "visualization": {}
            }
          ],
          "reduceOption": "sum",
          "mappings": [],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Total%20Energy%20Use%20By%20Host"
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "J"
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_POWER_USAGE",
              "aggregation": "sum",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {
                "unit": "W"
              },
              "splits": [
                "Hostname"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Power%20Draw%20By%20Host%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 2,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        }
      ]
    },
    {
      "widgetType": "Group",
      "title": {
        "dataType": "Title",
        "value": "Errors"
      },
      "position": {
        "x": 0,
        "y": 21,
        "w": 12,
        "h": 3
      },
      "children": [
        {
          "widgetType": "Stat",
          "position": {
            "x": 0,
            "y": 0,
            "w": 2,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_XID_ERRORS",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "max",
          "mappings": [
            {
              "operator": ">",
              "value": 0,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<=",
              "value": 0,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value "
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Total%20errors"
          },
          "fontSize": "auto",
          "columnConfigs": [],
          "unitOverride": "errors"
        },
        {
          "widgetType": "Stat",
          "position": {
            "x": 2,
            "y": 0,
            "w": 4,
            "h": 2
          },
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_XID_ERRORS",
              "aggregation": "sum",
              "label": "Cores Used",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 60,
              "splits": [
                "err_msg",
                "err_code"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "formulas": [],
          "reduceOption": "max",
          "mappings": [
            {
              "operator": ">",
              "value": 0,
              "color": "#d92e48",
              "type": "text",
              "textMapping": "$value"
            },
            {
              "operator": "<=",
              "value": 0,
              "color": "#2DD881",
              "type": "text",
              "textMapping": "$value "
            }
          ],
          "precision": 2,
          "metoroQLQueries": [],
          "title": {
            "dataType": "Title",
            "value": "Errors"
          },
          "fontSize": "auto",
          "columnConfigs": []
        },
        {
          "metricSpecifiers": [
            {
              "metricName": "DCGM_FI_DEV_XID_ERRORS",
              "aggregation": "sum",
              "label": "Active Connections",
              "metricType": "metric",
              "functions": [],
              "bucketSize": 0,
              "visualization": {},
              "splits": [
                "Hostname",
                "gpu"
              ],
              "filters": {
                "dataType": "Map",
                "value": [
                  [
                    "Hostname",
                    [
                      "$Host"
                    ]
                  ],
                  [
                    "gpu",
                    [
                      "$Host GPU"
                    ]
                  ]
                ]
              }
            }
          ],
          "type": "line",
          "widgetType": "MetricChart",
          "title": {
            "dataType": "Title",
            "value": "Errors%20by%20Host%20%2B%20GPU%20Over%20Time"
          },
          "position": {
            "x": 6,
            "y": 0,
            "w": 6,
            "h": 2
          },
          "metoroQLQueries": []
        }
      ]
    }
  ],
  "variables": [
    {
      "name": "Host",
      "key": "Hostname",
      "defaultType": "metric",
      "defaultMetricName": "DCGM_FI_DEV_GPU_TEMP",
      "defaultValue": "*",
      "isOverrideable": true
    },
    {
      "name": "Host GPU",
      "key": "gpu",
      "defaultType": "metric",
      "defaultMetricName": "DCGM_FI_DEV_GPU_TEMP",
      "defaultValue": "*",
      "isOverrideable": true
    }
  ]
}
`